import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        css: css`
            width: 60px;
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 75px;
                        `,
                        null,
                        css`
                            padding-right: 5px;
                        `,
                        css`
                            padding-right: 4px;
                        `,
                    ],
                    "minMax",
                )}
            & + div[class^="FormInputWrapper"] {
                width: calc(100% - 60px);
                select {
                    font-size: 13px;
                }
            }
        `,
    },
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};
